import useEventData from "../../../custom_hooks/useEventData";
import { useMemo } from "react";
import CelebrationsCardView from "./celebration-card.view";
import dayjs from "dayjs";
import Locale from "../../../core/locale/locale";

const Celebrations = () => {

    const startDate = dayjs().startOf('month').format(Locale.dateFormat);
    const endDate = dayjs().add(3, "month").endOf('month').format(Locale.dateFormat);

    const {data: {birthdays, workAnniversaries}, isLoading} = useEventData({
        startDate: startDate,
        endDate: endDate,
    });


    const celebrationData = useMemo(() => {
        const data = [...(birthdays ?? []), ...(workAnniversaries ?? [])];
        const today = dayjs().startOf("day");

        const sortedData = [...data].sort((a, b) => {
            const dateA = dayjs(a.startDate).startOf("day");
            const dateB = dayjs(b.startDate).startOf("day");

            const getPriority = (date: dayjs.Dayjs) => {
                if (date.isSame(today, "day")) return 0;
                if (date.isAfter(today, "day")) return 1;
                return 2;
            };

            const priorityA = getPriority(dateA);
            const priorityB = getPriority(dateB);

            if (priorityA !== priorityB) {
                return priorityA - priorityB;
            }

            return dateA.diff(dateB);
        });
        return sortedData;

    }, [birthdays, workAnniversaries]);

    return (
        <CelebrationsCardView
            celebration={celebrationData}
            loading={isLoading}
        />

    );
}

export default Celebrations;
